<div class="std-margin flex space-between">

  <span class="pointer uppercase bold" (click)="selectMode()"><i class="fa hlf-margin-right" [ngClass]="{'fa-boxes': mode == 'quantity', 'fa-coins': mode == 'worth'}"></i>{{(mode=='quantity' ? 'Xem theo số lượng' : 'Xem theo giá trị') | lang}}</span>
  
  <date-picker [force]="true" [handler]="handler"></date-picker>
</div>

<panel *ngIf="range && (!loading || !goods.empty)">

  <ng-container header *ngFor="let i of paths; index as ix">
    <span *ngIf="ix > 0" class="hlf-margin-left hlf-margin-right">|</span>
    <span *ngIf="ix != 1" [ngClass]="{'pointer text-primary': i.children.length > 0 && i != report}" (click)="open(i)">{{i.name}}</span>
    <good *ngIf="ix == 1" [sku]="i.name"></good>
  </ng-container>

  <text-filter [target]="goods" [placeholder]="'Tìm mã hàng'" right></text-filter>

  <table responsive class="data hover" *ngIf="mode == 'worth'">
    <tr>
      <th priority="7" class="text-top text-right" style="width: 0">STT</th>
      <th priority="1" class="text-top text-left"><sortable [target]="goods" [extractor]="extractor('last-of-path')">{{primaryLabel | lang}}</sortable></th>
      <th priority="3" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('initial')">{{'Tồn đầu' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('import')">{{'Nhập' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('return')">{{'Khách trả hàng' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('discount')">{{'Lỗi/thiếu mét' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('lost')">{{'Mất hàng' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('export')">{{'Xuất bán' | lang}}</sortable></th>
      <th priority="2" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('left')">{{'Tồn cuối' | lang}}</sortable></th>
      <th priority="6" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('exchange')">{{'Tỷ giá' | lang}}</sortable></th>
      <th priority="5" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('gross')">{{'Lãi gộp' | lang}}</sortable></th>
      <th priority="5" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('%')">{{'Lãi xuất' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of goods.pageMatches; index as ix">
      <td><small>{{ix + 1 + goods.pageIndex * goods.pageSize}}</small></td>
      <td>
        <div class="spacy bold" [ngClass]="{'pointer text-primary': i.children.length > 0, 'text-warning': i.children.length < 1}" (click)="open(i)">
          <span *ngIf="paths.length != 1">{{i.Path.last()}}</span>
          <good *ngIf="paths.length == 1" [sku]="i.Path.last()"></good>
        </div>
        <small *ngIf="paths.length < 2">{{i.children.length}}<unit>màu</unit></small>
      </td>

      <td class="nowrap">
        <number class="bold" [good]="'none'" [sign]="false" [value]="i.base('initial', 'CNY')" [decimal]="0"></number>
        <cny></cny>

        <div class="small pointer" (click)="openStatistics(i,'initial')" *ngIf="i.Initial.LengthCount + i.Initial.WeightCount > 0">
          <b>{{i.Initial.LengthQuantity + i.Initial.WeightQuantity | number : '1.0-1' : 'en-US'}}</b>{{(i.Initial.LengthCount > 0 ? (i.Initial.WeightCount > 0 ? 'đv' : 'm') : 'kg') | lang}} (<b>{{i.Initial.LengthCount + i.Initial.WeightCount}}</b> {{'cây' | lang}})
          <i class="fa fa-info-circle hlf-margin-left text-primary"></i>
        </div>

      </td>

      <td class="nowrap">

        <number class="bold" [sign]="false" [good]="'negative'" [value]="i.base('import', 'CNY') - i.base('provider', 'CNY')" [decimal]="0"></number>
        <cny></cny>

        <br />

        <small *ngIf="i.Imports.LengthCount + i.Imports.WeightCount > 0" class="pointer" (click)="openStatistics(i,'imports')">
          <number class="bold" [sign]="false" [good]="'none'" [value]="i.base('import','CNY')"></number>
          <b> - </b>
          <number [sign]="false" [good]="'none'" [value]="i.base('provider','CNY')"></number>
          <cny></cny>
          <i class="fa fa-info-circle hlf-margin-left text-primary"></i>
        </small>

      </td>

      <td class="nowrap">
        <number class="bold" [good]="'negative'" [sign]="false" [value]="i.quote('return', 'VND')" [decimal]="0"></number>
        <vnd></vnd>

        <br />

        <small *ngIf="i.Returns.LengthCount + i.Returns.WeightCount > 0" class="pointer" (click)="openStatistics(i, 'returns')">
          <number [sign]="false" [value]="i.gross('return', 'CNY')" [decimal]="0"></number>
          <b> + </b>
          <number class="bold" [sign]="false" [good]="'none'" [value]="i.base('return', 'CNY')"></number>
          <cny></cny>
          <i class="fa fa-info-circle hlf-margin-left text-primary"></i>
        </small>

      </td>

      <td class="nowrap">
        <number class="bold" [good]="'negative'" [sign]="false" [value]="i.quote('discount', 'VND')" [decimal]="0"></number>
        <vnd></vnd>

        <br />

        <small *ngIf="i.Exports.LengthDiscount + i.Exports.WeightDiscount + i.Imports.LengthDiscount + i.Imports.WeightDiscount > 0">
          <number [sign]="false" [value]="i.gross('discount', 'CNY')" [decimal]="0"></number>
          <b> + </b>
          <number class="bold" [sign]="false" [good]="'none'" [value]="i.base('discount', 'CNY')"></number>
          <cny></cny>
        </small>

      </td>

      <td class="nowrap">
        <number class="bold" [good]="'negative'" [sign]="false" [value]="i.base('lost','VND')" [decimal]="0"></number>
        <vnd></vnd>

        <br />

        <small *ngIf="i.CompanyLosses.LengthCount + i.CompanyLosses.WeightCount > 0">
          <number class="bold" [good]="'negative'" [sign]="false" [value]="i.base('lost', 'CNY')"></number>
          <cny></cny>
        </small>
      </td>

      <td class="nowrap">
        <number class="bold" [sign]="false" [value]="i.quote('export','VND')"></number>
        <vnd></vnd>

        <br />

        <small *ngIf="i.Exports.LengthCount + i.Exports.WeightCount > 0" class="pointer" (click)="openStatistics(i,'exports')">
          <number [sign]="false" [decimal]="0" [value]="i.gross('export','CNY')"></number>
          <b> + </b>
          <number class="bold" [sign]="false" [good]="'none'" [value]="i.base('export','CNY')"></number>
          <cny></cny>
          <i class="fa fa-info-circle hlf-margin-left text-primary"></i>
        </small>
      </td>

      <td class="nowrap">

        <number class="bold" [good]="'positive'" [value]="i.base('left', 'CNY')" [decimal]="0"></number>
        <cny></cny>
        <div class="small pointer" *ngIf="i.left('count') > 0" (click)="openStatistics(i,'remaining')">
          <b>{{i.left('quantity') | number : '1.0-1' : 'en-US'}}</b>{{(i.left('length-quantity') > 0 ? (i.left('weight-quantity') > 0 ? 'đv' : 'm') : 'kg') | lang}} (<b>{{i.left('count')}}</b> {{'cây' | lang}})
          <i class="fa fa-info-circle hlf-margin-left text-primary"></i>
        </div>
      </td>
      <td class="nowrap">
        <ng-container *ngIf="i.exchange != 0">
          <number [good]="'none'" [sign]="false" [value]="i.exchange" [decimal]="0"></number>
          <vnd-per-cny></vnd-per-cny>
        </ng-container>
      </td>
      <td class="nowrap">
        <number class="bold" [value]="i.gross('total','VND')" [decimal]="0"></number>
        <vnd></vnd>

        <br />

        <small *ngIf="i.gross('total','CNY') != 0">
          <number [good]="'positive'" [value]="i.gross('total', 'CNY')" [decimal]="0"></number>
          <b> / </b>
          <number [good]="'none'" [sign]="false" [value]="i.base('profitable', 'CNY')" [decimal]="0"></number>
          <cny></cny>
        </small>
      </td>
      <td class="nowrap">
        <number [good]="'positive'" [value]="i.base('profitable', 'CNY') != 0 ? i.gross('total', 'CNY') * 100 / i.base('profitable', 'CNY') : 0" [decimal]="1"></number>
        <unit>%</unit>
      </td>
    </tr>
    <tr *ngIf="goods.pages.length > 1">
      <td class="hidden"></td>
      <td [colSpan]="12" class="text-center" style="z-index: unset"><pagination [target]="goods"></pagination></td>
    </tr>
    <tr class="footer" *ngIf="goods.matches.length > 1">
      <td></td>
      <td class="bold">{{'TỔNG' | lang}} ({{goods.matches.length}})</td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('initial')" [decimal]="0"></number>
        <cny></cny>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('import')" [decimal]="0"></number>
        <cny></cny>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('return')" [decimal]="0"></number>
        <vnd></vnd>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('discount')" [decimal]="0"></number>
        <vnd></vnd>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('lost')" [decimal]="0"></number>
        <vnd></vnd>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('export')" [decimal]="0"></number>
        <vnd></vnd>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('left')" [decimal]="0"></number>
        <cny></cny>
      </td>
      <td class="nowrap">
        <number class="bold" [sign]="false" [good]="'none'" [value]="statistics('exchange')" [decimal]="0"></number>
        <vnd-per-cny></vnd-per-cny>
      </td>
      <td>
        <number class="bold" [value]="statistics('gross-value')" [decimal]="0"></number>
        <vnd></vnd>
      </td>
      <td>
        <number class="bold" [value]="statistics('gross-percentage') * 100" [decimal]="1"></number>
        <unit>%</unit>
      </td>
    </tr>
  </table>

  <table responsive class="data hover" *ngIf="mode == 'quantity'">
    <tr>
      <th priority="5" class="text-top text-right" style="width: 0">STT</th>
      <th priority="1" class="text-top text-left"><sortable [target]="goods" [extractor]="extractor('last-of-path')">{{primaryLabel}}</sortable></th>
      <th priority="3" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('initial-quantity')">{{'Tồn đầu' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('import-quantity')">{{'Nhập' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('return-quantity')">{{'Khách trả' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('discount-quantity')">{{'Lỗi/thiếu' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('lost-quantity')">{{'Mất hàng' | lang}}</sortable></th>
      <th priority="4" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('export-quantity')">{{'Xuất bán' | lang}}</sortable></th>
      <th priority="2" class="text-top text-right"><sortable [target]="goods" [extractor]="extractor('left-quantity')">{{'Tồn cuối' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of goods.pageMatches; index as ix">

      <td><small>{{ix + 1 + goods.pageIndex * goods.pageSize}}</small></td>
      <td>
        <div class="spacy bold" [ngClass]="{'pointer text-primary': i.children.length > 0, 'text-warning': i.children.length < 1}" (click)="open(i)">
          <span *ngIf="paths.length != 1">{{i.Path.last()}}</span>
          <good *ngIf="paths.length == 1" [sku]="i.Path.last()"></good>
        </div>
        <small *ngIf="paths.length < 2">{{i.children.length}}<unit>màu</unit></small>
      </td>

      <td class="nowrap">

        <div *ngIf="i.Initial.LengthCount > 0"><number class="bold" [good]="'none'" [sign]="false" [value]="i.Initial.LengthQuantity" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.Initial.WeightCount > 0"><number class="bold" [good]="'none'" [sign]="false" [value]="i.Initial.WeightQuantity" [decimal]="1"></number><kg></kg></div>
        <div *ngIf="i.Initial.LengthCount + i.Initial.WeightCount < 1">0</div>

        <small *ngIf="i.Initial.LengthCount + i.Initial.WeightCount > 0" class="pointer" (click)="openStatistics(i,'initial')">
          <number class="bold" [good]="'none'" [sign]="false" [value]="i.Initial.LengthCount + i.Initial.WeightCount"></number>
          <unit>{{'cây' | lang}}</unit> <i class="fa fa-info-circle hlf-margin-left text-primary"></i>
        </small>

      </td>

      <td class="nowrap">

        <div *ngIf="i.Imports.LengthCount > 0"><number class="bold" [good]="'negative'" [sign]="false" [value]="i.Imports.LengthQuantity - i.ProviderLosses.LengthQuantity" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.Imports.WeightCount > 0"><number class="bold" [good]="'negative'" [sign]="false" [value]="i.Imports.WeightQuantity - i.ProviderLosses.WeightQuantity" [decimal]="1"></number><kg></kg></div>
        <div *ngIf="i.Imports.LengthCount + i.Imports.WeightCount < 1">0</div>

        <small class="pointer" *ngIf="i.Imports.LengthCount + i.Imports.WeightCount > 0" (click)="openStatistics(i, 'imports')">
          <number class="bold" [sign]="false" [good]="'negative'" [value]="i.Imports.LengthCount + i.Imports.WeightCount"></number>
          <ng-container *ngIf="i.ProviderLosses.LengthCount + i.ProviderLosses.WeightCount > 0">
            <b> - </b>
            <number [sign]="false" [good]="'none'" [value]="i.ProviderLosses.LengthCount + i.ProviderLosses.WeightCount"></number>
          </ng-container>
          <unit>{{'cây' | lang}}</unit> <i class="fa fa-info-circle hlf-margin-left text-primary"></i>
        </small>

      </td>

      <td class="nowrap">
        <div *ngIf="i.Returns.LengthCount > 0"><number class="bold" [good]="'negative'" [sign]="false" [value]="i.Returns.LengthQuantity" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.Returns.WeightCount > 0"><number class="bold" [good]="'negative'" [sign]="false" [value]="i.Returns.WeightQuantity" [decimal]="1"></number><kg></kg></div>
        <div *ngIf="i.Returns.LengthCount + i.Returns.WeightCount < 1">0</div>

        <small *ngIf="i.Returns.LengthCount + i.Returns.WeightCount > 0" class="pointer" (click)="openStatistics(i,'returns')">
          <number [sign]="false" [good]="'negative'" [value]="i.Returns.LengthCount + i.Returns.WeightCount" [decimal]="0"></number>
          <unit>{{'cây' | lang}}</unit> <i class="fa fa-info-circle hlf-margin-left text-primary"></i>
        </small>

      </td>

      <td class="nowrap">
        <div *ngIf="i.Exports.LengthDiscount > 0"><number class="bold" [good]="'negative'" [sign]="false" [value]="i.Exports.LengthDiscount" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.Exports.WeightDiscount > 0"><number class="bold" [good]="'negative'" [sign]="false" [value]="i.Exports.WeightDiscount" [decimal]="1"></number><kg></kg></div>
        <div *ngIf="i.Exports.WeightDiscount + i.Exports.WeightDiscount < 1">0</div>

        <small *ngIf="i.Imports.LengthDiscount + i.Exports.LengthDiscount + i.Imports.WeightDiscount + i.Exports.WeightDiscount > 0">
          <number [sign]="false" [value]="i.Imports.LengthDiscount - i.Exports.LengthDiscount + i.Imports.WeightDiscount - i.Exports.WeightDiscount" [decimal]="1"></number>
          <b> + </b>
          <number class="bold" [sign]="false" [good]="'none'" [value]="i.Imports.LengthDiscount + i.Imports.WeightDiscount" [decimal]="1"></number>
          <m></m>
        </small>

      </td>

      <td class="nowrap">
        <div *ngIf="i.CompanyLosses.LengthCount > 0"><number class="bold" [good]="'negative'" [sign]="false" [value]="i.CompanyLosses.LengthQuantity" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.CompanyLosses.WeightCount > 0"><number class="bold" [good]="'negative'" [sign]="false" [value]="i.CompanyLosses.WeightQuantity" [decimal]="1"></number><kg></kg></div>
        <div *ngIf="i.CompanyLosses.LengthCount + i.CompanyLosses.WeightCount < 1">0</div>

        <small *ngIf="i.CompanyLosses.LengthCount + i.CompanyLosses.WeightCount > 0">
          <number class="bold" [good]="'negative'" [sign]="false" [value]="i.CompanyLosses.LengthCount + i.CompanyLosses.WeightCount"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      </td>

      <td class="nowrap">
        <div *ngIf="i.Exports.LengthCount > 0"><number class="bold" [sign]="false" [value]="i.Exports.LengthQuantity" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.Exports.WeightCount > 0"><number class="bold" [sign]="false" [value]="i.Exports.WeightQuantity" [decimal]="1"></number><kg></kg></div>
        <div *ngIf="i.Exports.LengthCount + i.Exports.WeightCount < 1">0</div>

        <small class="pointer" *ngIf="i.Exports.LengthCount + i.Exports.WeightCount > 0" (click)="openStatistics(i, 'exports')">
          <number class="bold" [sign]="false" [good]="'none'" [value]="i.Exports.LengthCount + i.Exports.WeightCount"></number>
          <unit>{{'cây' | lang}}</unit> <i class="fa fa-info-circle hlf-margin-left text-primary"></i>
        </small>
      </td>

      <td class="nowrap">
        <div *ngIf="i.left('length-count') > 0"><number class="bold" [sign]="false" [value]="i.left('length-quantity')" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.left('weight-count') > 0"><number class="bold" [sign]="false" [value]="i.left('weight-quantity')" [decimal]="1"></number><m></m></div>
        <div *ngIf="i.left('length-count') + i.left('weight-count') < 1">0</div>

        <small *ngIf="i.left('length-count') + i.left('weight-count') > 0" class="pointer" (click)="openStatistics(i, 'remaining')">
          <number class="bold" [good]="'positive'" [value]="i.left('length-count') + i.left('weight-count')"></number>
          <unit>{{'cây' | lang}}</unit> <i class="fa fa-info-circle hlf-margin-left text-primary"></i>
        </small>
      </td>

    </tr>
    <tr *ngIf="goods.pages.length > 1">
      <td class="hidden"></td>
      <td [colSpan]="9" class="text-center" style="z-index: unset"><pagination [target]="goods"></pagination></td>
    </tr>
    <tr class="footer" *ngIf="goods.matches.length > 1">
      <td></td>
      <td class="bold">{{'TỔNG' | lang}} ({{goods.matches.length}})</td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Initial', 'LengthQuantity') + sum('Initial', 'WeightQuantity')" [decimal]="0"></number>
        <m *ngIf="sum('Initial', 'WeightCount') < 1 && sum('Initial', 'LengthCount') > 0"></m>
        <kg *ngIf="sum('Initial', 'WeightCount') > 0 && sum('Initial', 'LengthCount') < 1"></kg>
        <unit *ngIf="sum('Initial', 'WeightCount') > 0 && sum('Initial', 'LengthCount') > 0">{{'đv' | lang}}</unit>
        <br />
        <small *ngIf="sum('Initial', 'LengthCount') + sum('Initial', 'WeightCount') > 0">
          <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Initial', 'LengthCount') + sum('Initial', 'WeightCount')" [decimal]="0"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Imports', 'LengthQuantity') - sum('ProviderLosses', 'LengthQuantity') + sum('Imports', 'WeightQuantity') - sum('ProviderLosses', 'WeightQuantity')" [decimal]="0"></number>
        <m *ngIf="sum('Imports', 'WeightCount') < 1 && sum('Imports', 'LengthCount') > 0"></m>
        <kg *ngIf="sum('Imports', 'WeightCount') > 0 && sum('Imports', 'LengthCount') < 1"></kg>
        <unit *ngIf="sum('Imports', 'WeightCount') > 0 && sum('Imports', 'LengthCount') > 0">{{'đv' | lang}}</unit>
        <br />
        <small *ngIf="sum('Imports', 'LengthCount') + sum('ProviderLosses', 'LengthCount') + sum('Imports', 'WeightCount') + sum('ProviderLosses', 'WeightCount') > 0">
          <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Imports', 'LengthCount') - sum('ProviderLosses', 'LengthCount') + sum('Imports', 'WeightCount') - sum('ProviderLosses', 'WeightCount')" [decimal]="0"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      </td>

      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Returns', 'LengthQuantity') + sum('Returns', 'WeightQuantity')" [decimal]="0"></number>
        <m *ngIf="sum('Returns', 'WeightCount') < 1 && sum('Returns', 'LengthCount') > 0"></m>
        <kg *ngIf="sum('Returns', 'WeightCount') > 0 && sum('Returns', 'LengthCount') < 1"></kg>
        <unit *ngIf="sum('Returns', 'WeightCount') > 0 && sum('Returns', 'LengthCount') > 0">{{'đv' | lang}}</unit>

        <br />
        <small *ngIf="sum('Returns', 'LengthCount') + sum('Returns', 'WeightCount') > 0">
          <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Returns', 'LengthCount') + sum('Returns', 'WeightCount')" [decimal]="0"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Exports', 'LengthDiscount') + sum('Exports', 'WeightDiscount')" [decimal]="0"></number>
        <m *ngIf="sum('Exports', 'WeightDiscount') < 1 && sum('Exports', 'LengthDiscount') > 0"></m>
        <kg *ngIf="sum('Exports', 'WeightDiscount') > 0 && sum('Exports', 'LengthDiscount') < 1"></kg>
        <unit *ngIf="sum('Exports', 'WeightDiscount') > 0 && sum('Exports', 'LengthDiscount') > 0">{{'đv' | lang}}</unit>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('CompanyLosses', 'LengthQuantity') + sum('CompanyLosses', 'WeightQuantity')" [decimal]="0"></number>
        <m *ngIf="sum('CompanyLosses', 'WeightCount') < 1 && sum('CompanyLosses', 'LengthCount') > 0"></m>
        <kg *ngIf="sum('CompanyLosses', 'WeightCount') > 0 && sum('CompanyLosses', 'LengthCount') < 1"></kg>
        <unit *ngIf="sum('CompanyLosses', 'WeightCount') > 0 && sum('CompanyLosses', 'LengthCount') > 0">{{'đv' | lang}}</unit>
        <br />
        <small *ngIf="sum('CompanyLosses', 'LengthCount') + sum('CompanyLosses', 'WeightCount') > 0">
          <number class="bold" [sign]="false" [good]="'none'" [value]="sum('CompanyLosses', 'LengthCount') + sum('CompanyLosses', 'WeightCount')" [decimal]="0"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Exports', 'LengthQuantity') + sum('Exports', 'WeightQuantity')" [decimal]="0"></number>
        <m *ngIf="sum('Exports', 'WeightCount') < 1 && sum('Exports', 'LengthCount') > 0"></m>
        <kg *ngIf="sum('Exports', 'WeightCount') > 0 && sum('Exports', 'LengthCount') < 1"></kg>
        <unit *ngIf="sum('Exports', 'WeightCount') > 0 && sum('Exports', 'LengthCount') > 0">{{'đv' | lang}}</unit>
        <br />
        <small *ngIf="sum('Exports', 'LengthCount') + sum('Exports', 'WeightCount') > 0">
          <number class="bold" [sign]="false" [good]="'none'" [value]="sum('Exports', 'LengthCount') + sum('Exports', 'WeightCount')" [decimal]="0"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      </td>
      <td>
        <number class="bold" [sign]="false" [good]="'none'" [value]="sum('left', 'length-quantity') + sum('left', 'weight-quantity')" [decimal]="0"></number>
        <m *ngIf="sum('left', 'weight-count') < 1 && sum('left', 'length-count') > 0"></m>
        <kg *ngIf="sum('left', 'weight-count') > 0 && sum('left', 'length-count') < 1"></kg>
        <unit *ngIf="sum('left', 'weight-count') > 0 && sum('left', 'length-count') > 0">{{'đv' | lang}}</unit>
        <br />
        <small *ngIf="sum('left', 'length-count') + sum('left', 'weight-count') > 0">
          <number class="bold" [sign]="false" [good]="'none'" [value]="sum('left', 'length-count') + sum('left', 'weight-count')" [decimal]="0"></number>
          <unit>{{'cây' | lang}}</unit>
        </small>
      </td>
    </tr>
  </table>
</panel>

<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
